import { ImageLoaderProps } from 'next/image'
type SafeNumber = number | `${number}`

interface ImageLoaderCustomHeightProps extends Omit<ImageLoaderProps, 'src' | 'width'> {
  src: string
  width?: SafeNumber
  height?: SafeNumber
}

export const cloudflareImageLoader = ({
  src,
  width,
  height,
  quality = 75,
  options,
}: Omit<ImageLoaderCustomHeightProps, 'config'> & { options?: { objectFit?: boolean } }) => {
  // Normalize the source URL
  src = src.replace(
    /https?:\/\/dustinweb\.azureedge\.net|\/\/dustinweb\.azureedge\.net/g,
    'https://media.dustin.eu'
  )
  // Remove any leading slash from the source URL
  src = src.startsWith('/') ? src.slice(1) : src

  // Build the Cloudflare image URL
  const transformations = [
    options?.objectFit ? 'fit=contain' : '',
    'format=auto',
    `quality=${quality}`,
    width ? `width=${width}` : '',
    height ? `height=${height}` : '',
    'fit=contain',
  ]
    .filter(Boolean)
    .join(',')

  return `https://cf-images.dustin.eu/cdn-cgi/image/${transformations}/${src}`
}
